import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { USE_MOCKED_DATA } from '../tokens/use-mocked-data.token';

export const blockMatrixApiInterceptor: HttpInterceptorFn = (req, next) => {
  const useMockedData = inject(USE_MOCKED_DATA);

  if (
    useMockedData &&
    environment.matrixApiUrl &&
    req.url.startsWith(environment.matrixApiUrl)
  ) {
    return throwError(
      () =>
        new Error(
          `Blocked HTTP request to ${req.url}. useMockedData is enabled. Use mock services instead.`
        )
    );
  }

  return next(req);
};
